<template>
  <div class="popular plr">
    <div class="popular_head">
      <!-- <div class="ti">{{ text('categories') }}</div> -->
      <a
        v-if="$store.getters.ecommercePopularCategoriesCount > 0 && categories.length > $store.getters.ecommercePopularCategoriesCount"
        @click="viewAll" class="view_all">{{ text('view_all') }}</a>
    </div>
    <ul class="category_list">
      <CategoryList
        :categories="$store.getters.ecommercePopularCategoriesCount > 0 ? categories.slice(0, $store.getters.ecommercePopularCategoriesCount) : categories"
        :preview="true"/>
    </ul>
  </div>
</template>

<style scoped>
  .cl_img img {
    -webkit-user-drag: none;
  }
</style>

<script>
  import ProductBlock from '@/components/Default/ProductBlock'
  import BubblesNavbar from '@/components/Default/BubblesNavbar'
  import {CREATE_SELECTED_CATEGORY_FOR_LEVEL, SET_MODAL, SET_SELECTED_CATEGORY} from '@/store/mutations.type'
  import CategoryItem from '@/components/ECommerce/Categories/CategoryItem'
  import CategoryList from '@/components/ECommerce/Categories/CategoryList'

  export default {
    name: 'CategoriesPreview',
    data() {
      return {}
    },
    components: {CategoryList, CategoryItem},
    watch: {},
    mounted() {

    },
    computed: {
      categories() {
        let categories = []
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].level === 0 && this.$store.getters.categories[i].id !== null) {
            categories.push(this.$store.getters.categories[i])
          }
        }
        return categories
      }
    },
    methods: {
      async viewAll() {
        let category = null
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].id === null) {
            category = this.$store.getters.categories[i]
            break
          }
        }

        await this.$store.commit(SET_SELECTED_CATEGORY, category)
        if (this.$route.name !== 'catalog') {
          await this.$router.push({name: 'catalog', params: {token: this.$store.getters.token}})
        }
        if (this.$store.getters.modal.search) {
          this.$store.commit(SET_MODAL, {modal: 'search', status: false})
          this.$store.commit(SET_MODAL, {modal: 'searchFull', status: false})
        }
      }
    }
  }
</script>
